import { render, staticRenderFns } from "./CustomerPricing.vue?vue&type=template&id=1af4b807&"
import script from "./CustomerPricing.vue?vue&type=script&lang=js&"
export * from "./CustomerPricing.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPricing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports